import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import { observer } from "mobx-react-lite"
import React from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"

interface Props {}

/**
 * Shows name of the form
 */
const OpenedFormName = observer(({}: Props) => {
	const formStore = useFormStore()
	const ptkmStore = usePTKMStore()
	const { t } = useTranslation()

	const location = useLocation()

	const getNameFromConfigType = () => {
		switch (true) {
			case location.pathname.includes(ROUTES.PTKM_CONFIGURATION):
				return ptkmStore.ptkmConfig.name
			case location.pathname.includes(ROUTES.REQUEST_CNFG):
				return formStore.selectedFormName
		}
	}
	const name = getNameFromConfigType()

	return (
		<div className="w-full text-left ">
			<p
				className="hide-overflown-text-nowrap uppercase  pl-6"
				style={{
					color: "var(--gray-4b)",
					background: "none",
				}}
			>
				{t("forms.field-label.name")} {":"} {name}
			</p>
		</div>
	)
})

export default OpenedFormName
